function setDescription() {
    if (document.querySelector('.show-more-wrapper')) {
        document.querySelectorAll('.show-more-wrapper').forEach(item => {
            let showMoreBtn = item.querySelector('.show-more-btn');
            let showLessBtn = item.querySelector('.show-less-btn');
            let contentWrapper = item.querySelector('.show-more-text-wrapper');

            console.log(showLessBtn, showMoreBtn, contentWrapper);

            if (showMoreBtn && showLessBtn && contentWrapper) {
                console.log('event listener set');
                showMoreBtn.addEventListener('click', function () {
                    console.log('test');
                    item.closest('.show-more-wrapper').classList.add('expanded');
                });

                showLessBtn.addEventListener('click', function () {
                    item.closest('.show-more-wrapper').classList.remove('expanded');
                });

                // Check if the content exceeds the max height
                if (contentWrapper.scrollHeight <= contentWrapper.clientHeight) {
                    showMoreBtn.style.display = 'none';
                }
            }
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    setDescription();
});
